<template>
    <BaseTabs
        :tab-ids="tabs.map((tab) => tab.path)"
        :labels="tabLabels"
        :model-value="currentTabPath"
        :orientation="isDesktop ? 'vertical' : 'horizontal'"
        class="min-h-0 w-full px-4 pt-6 lg:py-10 lg:pl-10 lg:pr-10"
        content-class="min-w-0 overflow-auto pt-6 lg:pt-0 lg:pl-10"
        @update:model-value="selectTab">
        <template v-for="tab in tabs" :key="tab.path" #[`content-${tab.path}`]>
            <slot v-if="tab.path === currentTabPath" />
        </template>
    </BaseTabs>
</template>

<script setup lang="ts">
import { useMediaQuery } from "@vueuse/core";
import BaseTabs from "~vue/components/BaseTabs.vue";
import { computed, type MaybeRef, unref } from "vue";

import type { TabPath } from "./types";

const { tabs, currentTabPath } = defineProps<{
    tabs: ReadonlyArray<{ label: MaybeRef<string>; path: TabPath; badge?: string }>;
    currentTabPath: string;
}>();

const emit = defineEmits<{
    "tab-selected": [path: TabPath];
}>();

const isDesktop = useMediaQuery("(min-width: 1024px)");
const tabLabels = computed(() => Object.fromEntries(tabs.map((tab) => [tab.path, tab.badge ? `${unref(tab.label)} (${tab.badge})` : unref(tab.label)])));

function selectTab(path: string | undefined) {
    const tab = tabs.find((tab) => tab.path === path);
    if (tab) {
        emit("tab-selected", tab.path);
    }
}
</script>
